export default __webpack_public_path__ + "static/media/property_679.21fbf185.png";